import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-white/80 pt-20 pb-10 border-t border-white/10" data-id="element-89">
      <div className="container mx-auto px-4 md:px-6" data-id="element-90">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-91">
          {/* Column 1: Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-92">
            <img src="https://cdn.magicpatterns.com/uploads/59rYsbJUbt55RQXPPouc6w/1PAZ-and-AZDH-Logo-V1-REDUCED.png" alt="One Percent Listing AZ Logo" className="h-16 object-contain mb-4 bg-white p-2 rounded-sm" data-id="element-93" />
            <p className="text-gold font-serif text-lg mb-2" data-id="element-94">
              Luxury Listings at 1%.
            </p>
            <p className="text-xs text-white/50 uppercase tracking-wider" data-id="element-95">
              Brokered by AZ Dream Homes
            </p>
          </div>

          {/* Column 2: Contact */}
          <div className="text-center md:text-left" data-id="element-96">
            <h4 className="text-gold font-serif text-xl mb-6" data-id="element-97">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-98">
              <li data-id="element-99">
                <a href="tel:4802562262" className="hover:text-brick-red transition-colors" data-id="element-100">
                  (480) 256-2262
                </a>
              </li>
              <li data-id="element-101">
                <a href="mailto:info@onepercentlistingaz.com" className="hover:text-brick-red transition-colors" data-id="element-102">
                  info@onepercentlistingaz.com
                </a>
              </li>
              <li className="leading-relaxed" data-id="element-103">
                6991 E Camelback Rd
                <br data-id="element-104" />
                Suite D-300
                <br data-id="element-105" />
                Scottsdale, AZ 85251
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div className="text-center md:text-left" data-id="element-106">
            <h4 className="text-gold font-serif text-xl mb-6" data-id="element-107">Quick Links</h4>
            <ul className="space-y-3 text-sm" data-id="element-108">
              <li data-id="element-109">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-110">
                  List for 1%
                </a>
              </li>
              <li data-id="element-111">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-112">
                  Buyer Rebate
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-114">
                  About Us
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-116">
                  FAQ
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-118">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Services */}
          <div className="text-center md:text-left" data-id="element-119">
            <h4 className="text-gold font-serif text-xl mb-6" data-id="element-120">Our Services</h4>
            <ul className="space-y-3 text-sm" data-id="element-121">
              <li data-id="element-122">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-123">
                  Online Presence
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-125">
                  Expert Guidance
                </a>
              </li>
              <li data-id="element-126">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-127">
                  MLS Listings
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-129">
                  Professional Photos
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-131">
                  Cash Option
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="hover:text-brick-red transition-colors" data-id="element-133">
                  High Security
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gold/20 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-134">
          <div className="text-xs text-white/50 text-center md:text-left" data-id="element-135">
            © 2026 One Percent Listing AZ. All rights reserved.
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-136">
            <div className="flex items-center gap-2 text-xs text-white/50" data-id="element-137">
              <span className="w-4 h-4 border border-white/50 flex items-center justify-center rounded-sm text-[8px]" data-id="element-138">
                EHO
              </span>
              <span data-id="element-139">Equal Housing Opportunity</span>
              <span className="mx-2" data-id="element-140">•</span>
              <span data-id="element-141">Licensed in Arizona</span>
            </div>
          </div>

          <div className="flex items-center gap-6" data-id="element-142">
            <div className="flex gap-4 text-xs text-white/50" data-id="element-143">
              <a href="#" className="hover:text-white transition-colors" data-id="element-144">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-145">
                Terms of Service
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-146">
                Cookie Policy
              </a>
            </div>
            <div className="flex gap-4" data-id="element-147">
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-148">
                <Instagram className="w-5 h-5" data-id="element-149" />
              </a>
              <a href="#" className="text-gold hover:text-white transition-colors" data-id="element-150">
                <Facebook className="w-5 h-5" data-id="element-151" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}